import { type DischargePlanViewModel } from '@generated';
import { SectionCard } from '~/shared/section/SectionCard';

export function EstimatedDischargeDate({
	dischargePlan,
	estimatedDischargeDate
}: {
	dischargePlan: DischargePlanViewModel;
	estimatedDischargeDate?: Date;
}) {
	if (dischargePlan.noPlannedDischarge) {
		return (
			<SectionCard
				title="Expected Discharge Date"
				value="No Planned Discharge"
				description={dischargePlan.reasonForNoPlannedDischarge ?? 'No reason provided'}
			/>
		);
	} else if (!estimatedDischargeDate) {
		return <SectionCard title="Expected Discharge Date" value="Unknown" description="Estimated discharge date is not available" />;
	}

	return (
		<SectionCard
			title="Expected Discharge Date"
			value={estimatedDischargeDate.toLocaleDateString()}
			description="Patient is currently scheduled for discharge on this date"
		/>
	);
}
